export const CHAT_MODE = process.env.VUE_APP_CHAT_MODE || 'tim';

export function isWebSocketChat() {
  return CHAT_MODE === 'websocket';
}



// WEBPACK FOOTER //
// ./src/utils/chat-config.js